import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from 'store';
import { AcademyState, AcademyLive } from 'store/modules/academy_store/types';
import Loader from 'components/atoms/loader';
import AcademyButton from 'components/atoms/academy_button';
import AcademyEventRow from 'components/molecules/academy_event_row';
import SubscribedIcon from 'assets/images/icon_starred_seet_blue.svg';
import { Container } from './styles';

const AcademyMyTrainings: React.FC = () => {
  const history = useHistory();
  const { mySubscriptions, request } = useSelector<ApplicationState, AcademyState>(
    (s) => s.session.academy,
  );

  const upcoming = mySubscriptions
    .map((sub) => sub.live)
    .filter(
      (live): live is AcademyLive => Boolean(live) && ['scheduled', 'live'].includes(live!.status),
    );
  const recordings = mySubscriptions
    .map((sub) => sub.live)
    .filter(
      (live): live is AcademyLive =>
        Boolean(live) && live!.status === 'finished' && Boolean(live!.recording_embed_url),
    );

  if (request.mySubscriptions.loading) {
    return (
      <Container>
        <div className="loading-wrapper">
          <Loader />
        </div>
      </Container>
    );
  }

  if (mySubscriptions.length === 0) {
    return (
      <Container>
        <div className="empty-state">
          <i className="material-icons">school</i>
          <p>Você ainda não se inscreveu em nenhuma transmissão.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      {upcoming.length > 0 && (
        <>
          <div className="section-label">Próximos</div>
          {upcoming.map((live) => (
            <AcademyEventRow
              key={live.id}
              live={live}
              action={
                live.status === 'live' ? (
                  <AcademyButton icon="live_tv" onClick={() => history.push('/academy/ao-vivo')}>
                    Assistir
                  </AcademyButton>
                ) : (
                  <AcademyButton variant="outline" imgIcon={SubscribedIcon}>
                    Inscrito
                  </AcademyButton>
                )
              }
            />
          ))}
        </>
      )}

      {recordings.length > 0 && (
        <>
          <div className="section-label month-gap">Gravações</div>
          {recordings.map((live) => (
            <AcademyEventRow
              key={live.id}
              live={live}
              action={
                <AcademyButton
                  onClick={() => history.push(`/academy/meus-treinamentos/${live.id}`)}
                >
                  Assistir
                </AcademyButton>
              }
            />
          ))}
        </>
      )}
    </Container>
  );
};

export default AcademyMyTrainings;
